var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEcranW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.21 37.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_358",
    "data-name": "Groupe 358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3942-3",
    "data-name": "Trac\\xE9 3942-3",
    d: "M23.25,18.6a.58.58,0,0,1-.58-.58h0V14h-.58a.58.58,0,1,1,0-1.16h1.16a.58.58,0,0,1,.58.58h0v3.36l4.27-3.79a.56.56,0,0,1,.39-.15h7a.58.58,0,0,0,.58-.58V1.74a.58.58,0,0,0-.58-.58H19.18a.58.58,0,0,0-.58.58v8.72a.58.58,0,1,1-1.16,0V1.74A1.74,1.74,0,0,1,19.18,0H35.46a1.76,1.76,0,0,1,1.75,1.74V12.21A1.76,1.76,0,0,1,35.46,14H28.71l-5.07,4.5A.56.56,0,0,1,23.25,18.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3943-3",
    "data-name": "Trac\\xE9 3943-3",
    d: "M34.88,31.4a.58.58,0,0,1-.58-.58h0V17.44a.58.58,0,0,1,1.16,0V30.82a.58.58,0,0,1-.58.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3944-3",
    "data-name": "Trac\\xE9 3944-3",
    d: "M2.33,31.4a.58.58,0,0,1-.59-.58h0V11.05A2.92,2.92,0,0,1,4.65,8.14H14.83a.58.58,0,0,1,.58.58.59.59,0,0,1-.58.59H4.65a1.74,1.74,0,0,0-1.74,1.74V30.82a.58.58,0,0,1-.58.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3945-3",
    "data-name": "Trac\\xE9 3945-3",
    d: "M33.14,37.21H4.07A4.07,4.07,0,0,1,0,33.14a.58.58,0,0,1,.58-.58h14a.58.58,0,0,1,.58.58h0v.58h7v-.58a.58.58,0,0,1,.58-.58H36.62a.58.58,0,0,1,.58.58h0A4.07,4.07,0,0,1,33.14,37.21ZM1.22,33.72a2.93,2.93,0,0,0,2.85,2.33H33.14A2.91,2.91,0,0,0,36,33.72H23.25v.58a.58.58,0,0,1-.58.58H14.53A.58.58,0,0,1,14,34.3h0v-.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3946-3",
    "data-name": "Trac\\xE9 3946-3",
    d: "M24.42,30.81a.57.57,0,0,1-.58-.55s-.17-2.64-2-3.57L18,25.05a8.19,8.19,0,0,1-5.81,0L8.39,26.69c-1.83.93-2,3.55-2,3.57a.59.59,0,0,1-1.17-.06c0-.13.2-3.33,2.65-4.56h0L12,23.88a.6.6,0,0,1,.49,0,7,7,0,0,0,5.3,0,.6.6,0,0,1,.49,0l4.07,1.75h0C24.81,26.87,25,30.07,25,30.2a.57.57,0,0,1-.55.61h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3947-3",
    "data-name": "Trac\\xE9 3947-3",
    d: "M16.86,22.67a.57.57,0,0,1-.58-.58.56.56,0,0,1,.26-.48c1.4-.94,1.46-1.42,1.63-2.86,0-.1,0-.21,0-.33A4.16,4.16,0,0,0,18,16a2.8,2.8,0,0,0-1.63-1.29,3.87,3.87,0,0,0-2.47,0A2.75,2.75,0,0,0,12.26,16,4.08,4.08,0,0,0,12,18.42c0,.12,0,.23,0,.33.17,1.44.23,1.92,1.63,2.86a.59.59,0,0,1,.17.81.6.6,0,0,1-.81.16h0a4.08,4.08,0,0,1-2.14-3.69c0-.11,0-.22,0-.33a5.13,5.13,0,0,1,.36-3.07,4,4,0,0,1,2.28-1.86,5.18,5.18,0,0,1,3.21,0A4,4,0,0,1,19,15.49a5.13,5.13,0,0,1,.36,3.07c0,.11,0,.22,0,.33a4.08,4.08,0,0,1-2.14,3.69A.59.59,0,0,1,16.86,22.67Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEcranW);
export default __webpack_public_path__ + "static/media/ic-ecran-w.e118508c645e534688f044223ab316ea.svg";
export { ForwardRef as ReactComponent };